export default __webpack_public_path__ + "static/media/0.0a5b62ec.jpg";